<form class="page-search">

  <mat-form-field appearance="outline">
    <mat-label>{{ searchLabel }}</mat-label>
    <input matInput [value]="value">
  </mat-form-field>

</form>
